import { Component, inject } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';

import { LayoutService } from '@layout/service/layout.service';
import { environment } from '@env/environment';
import { AuthService } from '@core/services/auth.service';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [RouterModule, CommonModule, StyleClassModule],
  template: ` <div class="layout-topbar">
    <div class="layout-topbar-logo-container">
      <button
        class="layout-menu-button layout-topbar-action"
        (click)="layoutService.onMenuToggle()">
        <i class="pi pi-bars"></i>
      </button>
      <a class="layout-topbar-logo" routerLink="/">
        <img [src]="app.logo" [alt]="app.name" />
        @if (app.subName) {
          <span [innerHTML]="app.subName"></span>
        }
      </a>
    </div>

    <div class="layout-topbar-actions">
      <button
        class="layout-topbar-menu-button layout-topbar-action"
        pStyleClass="@next"
        enterFromClass="hidden"
        enterActiveClass="animate-scalein"
        leaveToClass="hidden"
        leaveActiveClass="animate-fadeout"
        [hideOnOutsideClick]="true">
        <i class="pi pi-ellipsis-v"></i>
      </button>

      <div class="layout-topbar-menu hidden lg:block">
        <div class="layout-topbar-menu-content">
          <!-- <button type="button" class="layout-topbar-action">
            <i class="pi pi-calendar"></i>
            <span>Calendar</span>
          </button>
          <button type="button" class="layout-topbar-action">
            <i class="pi pi-inbox"></i>
            <span>Messages</span>
          </button> -->
          <button type="button" class="layout-topbar-action" [routerLink]="'/perfil'">
            <i class="pi pi-user"></i>
            <span>Profile</span>
          </button>
          <button type="button" class="layout-topbar-action" (click)="logout()">
            <i class="pi pi-power-off"></i>
            <span>Cerrar sesión</span>
          </button>
        </div>
      </div>
    </div>
  </div>`,
})
export class AppTopbar {
  private readonly authService = inject(AuthService);
  items!: MenuItem[];
  readonly app = environment.app;

  constructor(public layoutService: LayoutService) {}

  async logout() {
    await this.authService.logout();
  }
}
